import {
  Link,
  Message,
  Typography,
} from "@visma-netvisor/react-component-library";
import { getLanguageId, LanguageId } from "../../i18";
import { StarFilledIcon } from "@visma-netvisor/nv-react-icons";
import { Trans, useTranslation } from "react-i18next";

export const AdContainerActivated = () => {
  const { t } = useTranslation();

  const { i18n } = useTranslation();
  const language = i18n.language;
  const languageId = getLanguageId(language);

  const newCompanyInfoLink = 
    languageId === LanguageId.Finnish
      ? "https://netvisor.fi/wp-content/uploads/2026/01/Uudet-yritykset-2026-kampanjan-ehdot-ja-saannot.pdf"
      : "https://netvisor.fi/wp-content/uploads/2026/01/Terms-and-conditions-of-the-new-companies-campaign-2026.pdf";

  return (
    <Message
      fullWidth
      variant="info"
      iconOverride={<StarFilledIcon />}
    >
      <Typography
        as="h4"
        color="info"
        styleOverrides={{ marginBottom: 8 }}
        variant="headingH4Bold"
      >
        {t("CompanyInformation.AdCampaignActivatedTitle")}
      </Typography>
      <Typography
        as="p"
        color="info"
        styleOverrides={{ marginBottom: 8 }}
        variant="contentHeadingH4Regular"
      >
        {t("CompanyInformation.AdDescription1")}
      </Typography>
      <Typography
        as="p"
        color="info"
        styleOverrides={{ marginBottom: 16 }}
        variant="contentHeadingH4Regular"
      >
        <Trans
          i18nKey="CompanyInformation.AdLink"
          components={[
            <Link
              target="_blank"
              style={{ cursor: "pointer" }}
              href={newCompanyInfoLink}
            ></Link>
          ]}
        />
      </Typography>
      <Typography
        as="p"
        color="info"
        variant="contentHeadingH4Regular"
      >
        {t("CompanyInformation.AdCampaignActivatedText")}
      </Typography>
      <Typography
        as="p"
        color="info"
        styleOverrides={{ marginTop: 16, marginBottom: 4 }}
        variant="contentHeadingH4Regular"
      >
        {t("CompanyInformation.AdCampaignCancelTitle")}
      </Typography>
      <ul style={{ marginTop: 0, marginBottom: 0, paddingLeft: 24 }}>
        <Typography
          as="li"
          color="info"
          variant="contentHeadingH4Regular"
        >
          {t("CompanyInformation.AdCampaignCancelText1")}
        </Typography>
        <Typography
          as="li"
          color="info"
          variant="contentHeadingH4Regular"
        >
          {t("CompanyInformation.AdCampaignCancelText2")}
        </Typography>
      </ul>
    </Message>
  );
};

export default AdContainerActivated;
